export default {
  lockedPromoCodeOfferFillColor: '#ff8631',
  textTransform: Styles.textTransform.headlines,
  expiresPrefix: '',
};
